/**
 * DTO type for Picking Station
 * This will be replaced with the actual DTO from @peritasai/types when the API is ready
 */
export interface PickingStationDto {
  id: string;
  name: string;
  status: 'Available' | 'Busy' | 'Offline';
  locationDisplayName?: string;
  assetLifecycleFunction?: string;
  /** The location this station's sidehub sits in — distinct from `id`, which is the sidehub's own id. */
  locationId?: string | null;
}

/**
 * Represents a picking station used for cart and tray detection.
 */
export class PickingStationEntity {
  public readonly id: string;
  public readonly name: string;
  public readonly status: 'Available' | 'Busy' | 'Offline';
  public readonly locationDisplayName?: string;
  public readonly assetLifecycleFunction?: string;
  public readonly locationId: string | null;

  constructor(dto: PickingStationDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.status = dto.status;
    this.locationDisplayName = dto.locationDisplayName;
    this.assetLifecycleFunction = dto.assetLifecycleFunction;
    this.locationId = dto.locationId ?? null;
  }

  static fromDTO(dto: PickingStationDto): PickingStationEntity {
    return new PickingStationEntity(dto);
  }

  toDTO(): PickingStationDto {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
      locationDisplayName: this.locationDisplayName,
      assetLifecycleFunction: this.assetLifecycleFunction,
      locationId: this.locationId,
    };
  }

  /**
   * Returns true if the station is available for use
   */
  get isAvailable(): boolean {
    return this.status === 'Available';
  }

  /**
   * Returns true if the station is currently in use
   */
  get isBusy(): boolean {
    return this.status === 'Busy';
  }

  /**
   * Returns true if the station is offline/disconnected
   */
  get isOffline(): boolean {
    return this.status === 'Offline';
  }
}
